export default __webpack_public_path__ + "static/Topseli-3690cd0d2196b2fb83e74522724beff9.png";